import { render, staticRenderFns } from "./partsMess.vue?vue&type=template&id=c5e5be42&scoped=true"
import script from "./partsMess.vue?vue&type=script&lang=js"
export * from "./partsMess.vue?vue&type=script&lang=js"
import style0 from "./partsMess.vue?vue&type=style&index=0&id=c5e5be42&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e5be42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e5be42')) {
      api.createRecord('c5e5be42', component.options)
    } else {
      api.reload('c5e5be42', component.options)
    }
    module.hot.accept("./partsMess.vue?vue&type=template&id=c5e5be42&scoped=true", function () {
      api.rerender('c5e5be42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/partsMess.vue"
export default component.exports